import { render } from "./AppPreloader.vue?vue&type=template&id=46632660&scoped=true"
import script from "./AppPreloader.vue?vue&type=script&lang=js"
export * from "./AppPreloader.vue?vue&type=script&lang=js"

import "./AppPreloader.vue?vue&type=style&index=0&id=46632660&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46632660"]])

export default __exports__